export const SmsType = {
  GET_SMS_DATA: "GET_SMS_DATA",
};
